import React from 'react';

import { flowRight } from 'lodash';
import AppLoaded from '../../../common/components/app-loaded';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { connect } from '../../../common/components/runtime-context';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import { getLanguage } from '../../../common/store/basic-params/basic-params-selectors';
import { getTranslations } from '../../../common/store/translations/translations-selectors';
import TagCloud from '../tag-cloud';
import styles from './app-root.scss';

const AppRoot = () => {
  return (
    <ResponsiveListener className={styles.baseStyles}>
      <TagCloud />
      <AppLoaded />
    </ResponsiveListener>
  );
};

const mapRuntimeToProps = (state) => ({
  language: getLanguage(state),
  translations: getTranslations(state),
});

export default flowRight(withReduxStore, connect(mapRuntimeToProps))(AppRoot);
